import { useState } from 'react';
import { useForm, FieldErrors, UseFormSetError } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useAuthContext } from 'contexts/Auth';
import { apiFetch } from 'services/apiFetch';
import { setToken } from 'services/auth';
import yup from 'utils/yup';

type UseFormType = Partial<{
  errors: FieldErrors;
  setError: UseFormSetError<any>;
  control: any;
}> & {
  onSubmit: () => void,
  loading: boolean,
};

const schema = yup.object().shape({
  password: yup.string()
    .required()
    .label('Senha'),
});

export default (
  { afterSubmit }:{ afterSubmit: () => void },
):UseFormType => {
  const { email, setName } = useAuthContext();
  const [loading, setLoading] = useState(false);

  const {
    handleSubmit, setError, control, formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
    defaultValues: { password: '' },
  });

  const onSubmit = handleSubmit(async (formData) => {
    setLoading(true);

    const response = await apiFetch('/session', {
      method: 'POST',
      body: JSON.stringify({ email, password: formData.password }),
    });

    if (response.ok) {
      const data = await response.json() as {
        id: number, name: string, email: string, token: string,
      };
      setToken(data.token);
      setName(data.name);
      afterSubmit();
    } else {
      setError('password', {
        type: 'check-login',
        message: 'Impossível fazer login com as credenciais fornecidas.',
      });
    }

    setLoading(false);
  });

  return {
    errors,
    setError,
    control,
    loading,
    onSubmit,
  };
};
